// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__BkUkR","footer":"ChangeClinic_footer__14tXk"};